export const OTF = 'opentype'
export const TTF = 'truetype'
export const WOFF = 'woff'
export const WOFF2 = 'woff2'
